import React, { Component } from "react";
import { toast } from "react-toastify";
import Table from "./common/table";
import auth from "../services/authService";
import { getRep_ } from "../services/dreamNewService";
import { blockedShortCodeList, isBlockedShortCode } from "../utils/shortCodeStatus";

class Report extends Component {
  state = {
    data: [],
    dataAdib: [],
    dataQutaiba: [],
    dataMona: [],
    dataAdibM: [],
    dataQutaibaM: [],
    dataMonaM: [],
    dataSMS: [],
    dataSMSM: [],
    sortColumn: "",
    username: "",
    lastUpdated: null,
    shortCodeGroupFilter: "all",
  };

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  async tick() {
    try {
      const email = auth.getCurrentUser();
      let data = await getRep_(email);
      data = data.data;

      const dataAdib = data.MCDMY.filter((m) => m.ReplyUserName === "adib@salmustasharak.com");
      const dataMona = data.MCDMY.filter((m) => m.ReplyUserName === "mohannad@salmustasharak.com");

      const dataAdibM = data.MCMY.filter((m) => m.ReplyUserName === "adib@salmustasharak.com");
      const dataMonaM = data.MCMY.filter((m) => m.ReplyUserName === "mohannad@salmustasharak.com");

      const dataSMS = data.SCDMY.filter(
        (m) => m.Day === new Date().getDate() && m.Year === new Date().getFullYear() && m.Month === new Date().getMonth() + 1
      );
      const dataSMSM = data.SCMY.filter(
        (m) => m.Year === new Date().getFullYear() && m.Month === new Date().getMonth() + 1
      );

      this.setState({
        data: data.Data,
        dataAdib,

        dataMona,
        dataAdibM,

        dataMonaM,
        dataSMS,
        dataSMSM,
        username: email,
        lastUpdated: new Date(),
      });
    } catch (ex) {
      console.log(ex);
      toast.error("يوجد خطأ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      if (ex.response && ex.response.status === 404) toast.error("This mob has already been deleted.");
    }
  }

  async componentDidMount() {
    await this.tick();
    this.timerID = setInterval(async () => {
      if (!this.state.isStop) {
        await this.tick();
      }
    }, 30000);
  }

  columnsMufasserCountDMY = [
    { path: "MsgCount", label: "العدد" },
    { path: "Year", label: "السنة" },
    { path: "Month", label: "الشهر" },
    { path: "Day", label: "اليوم" },
  ];
  columnsMufasserCountMY = [
    { path: "MsgCount", label: "العدد" },
    { path: "Year", label: "السنة" },
    { path: "Month", label: "الشهر" },
  ];

  columnsNowSMSCountDMY = [
    { path: "ShortCode", label: "الشورت كود" },
    { path: "CountMsg", label: "العدد" },
    { path: "Year", label: "السنة" },
    { path: "Month", label: "الشهر" },
    { path: "Day", label: "اليوم" },
  ];

  columnsNowSMSCountMY = [
    { path: "ShortCode", label: "الشورت كود" },
    { path: "CountMsg", label: "العدد" },
    { path: "Year", label: "السنة" },
    { path: "Month", label: "الشهر" },
  ];

  getCountMap = (items) => {
    const map = {};
    if (!Array.isArray(items)) return map;
    items.forEach((item) => {
      const code = Number(item.ShortCode);
      const count = Number(item.CountMsg) || 0;
      if (!Number.isNaN(code)) {
        map[code] = (map[code] || 0) + count;
      }
    });
    return map;
  };

  getShortCodeSummary = (items) => {
    const map = this.getCountMap(items);
    const total = Object.values(map).reduce((sum, value) => sum + value, 0);
    const oldTotal = blockedShortCodeList.reduce(
      (sum, code) => sum + (map[code] || 0),
      0
    );
    const otherTotal = Math.max(total - oldTotal, 0);
    const topEntry = Object.entries(map).sort((a, b) => b[1] - a[1])[0];
    const topCode = topEntry ? Number(topEntry[0]) : null;
    const topCount = topEntry ? topEntry[1] : 0;

    return { map, total, oldTotal, otherTotal, topCode, topCount };
  };

  getShortCodeRows = (dayMap, monthMap) => {
    const allCodes = new Set([
      ...Object.keys(dayMap || {}),
      ...Object.keys(monthMap || {}),
      ...blockedShortCodeList.map(String),
    ]);

    return Array.from(allCodes)
      .map((codeStr) => {
        const code = Number(codeStr);
        return {
          ShortCode: code,
          DayCount: dayMap[code] || 0,
          MonthCount: monthMap[code] || 0,
          Group: isBlockedShortCode(code) ? "قديم" : "أحلامكم",
        };
      })
      .sort((a, b) => a.ShortCode - b.ShortCode);
  };

  getColumnTotals = (items, columns) => {
    if (!Array.isArray(items)) return {};
    return columns.reduce((totals, column) => {
      if (!column.path) return totals;
      const total = items.reduce((sum, item) => {
        const value = Number(item[column.path]);
        return sum + (Number.isNaN(value) ? 0 : value);
      }, 0);
      totals[column.path] = total;
      return totals;
    }, {});
  };

  renderTotalsFooter = (columns, totals) => (
    <tr className="report-table__footer">
      {columns.map((column, index) => {
        const key = column.path || column.key || index;
        const value =
          totals[column.path] !== undefined ? totals[column.path] : 0;
        if (index === 0) {
          return <td key={key}>{`الإجمالي: ${value}`}</td>;
        }
        return <td key={key}>{value}</td>;
      })}
    </tr>
  );

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handleShortCodeGroupFilter = (event) => {
    this.setState({ shortCodeGroupFilter: event.target.value });
  };

  render() {
    const {
      dataAdib,
      dataQutaiba,
      dataMona,
      dataAdibM,
      dataQutaibaM,
      dataMonaM,
      dataSMS,
      sortColumn,
      username,
      dataSMSM,
      lastUpdated,
      shortCodeGroupFilter,
    } = this.state;

    const daySummary = this.getShortCodeSummary(dataSMS);
    const monthSummary = this.getShortCodeSummary(dataSMSM);
    const shortCodeRows = this.getShortCodeRows(
      daySummary.map,
      monthSummary.map
    );
    const filteredShortCodeRows =
      shortCodeGroupFilter === "all"
        ? shortCodeRows
        : shortCodeRows.filter(
            (row) =>
              row.Group ===
              (shortCodeGroupFilter === "old" ? "قديم" : "أحلامكم")
          );
    const shortCodeTotals = filteredShortCodeRows.reduce(
      (totals, row) => {
        totals.day += row.DayCount;
        totals.month += row.MonthCount;
        if (row.Group === "قديم") {
          totals.old += 1;
        } else {
          totals.new += 1;
        }
        return totals;
      },
      { day: 0, month: 0, old: 0, new: 0 }
    );
    const totalsMufasserDMY = this.getColumnTotals(
      dataAdib,
      this.columnsMufasserCountDMY
    );
    const totalsMufasserDMYMona = this.getColumnTotals(
      dataMona,
      this.columnsMufasserCountDMY
    );
    const totalsMufasserMY = this.getColumnTotals(
      dataAdibM,
      this.columnsMufasserCountMY
    );
    const totalsMufasserMYMona = this.getColumnTotals(
      dataMonaM,
      this.columnsMufasserCountMY
    );
    const totalsQutaibaDMY = this.getColumnTotals(
      dataQutaiba,
      this.columnsMufasserCountDMY
    );
    const totalsQutaibaMY = this.getColumnTotals(
      dataQutaibaM,
      this.columnsMufasserCountMY
    );
    const uniqueOtherCodes = shortCodeRows.filter(
      (row) => row.Group === "أحلامكم"
    ).length;

    return (
      <div className="report-page">
        <div className="report-header">
          <div className="report-title">تقارير الشورت كود</div>
          <div className="report-meta">
            آخر تحديث:{" "}
            {lastUpdated ? lastUpdated.toLocaleString("ar-EG") : "—"}
          </div>
        </div>

        <div className="report-grid report-grid--summary">
          <div className="control-card report-card report-card--day">
            <div className="report-card__title">ملخص اليوم</div>
            <div className="report-card__value">{daySummary.total}</div>
            <div className="report-card__meta">
              شورت كود قديم: {daySummary.oldTotal}
            </div>
            <div className="report-card__meta">
              أحلامكم: {daySummary.otherTotal}
            </div>
            <div className="report-card__meta">
              الأكثر نشاطاً:{" "}
              {daySummary.topCode
                ? `${daySummary.topCode} (${daySummary.topCount})`
                : "—"}
            </div>
          </div>

          <div className="control-card report-card report-card--ahlamkom">
            <div className="report-card__title">ملخص اليوم أحلامكم</div>
            <div className="report-card__value">{daySummary.otherTotal}</div>
          </div>

          <div className="control-card report-card report-card--month">
            <div className="report-card__title">ملخص الشهر</div>
            <div className="report-card__value">{monthSummary.total}</div>
            <div className="report-card__meta">
              شورت كود قديم: {monthSummary.oldTotal}
            </div>
            <div className="report-card__meta">
              أحلامكم: {monthSummary.otherTotal}
            </div>
            <div className="report-card__meta">
              الأكثر نشاطاً:{" "}
              {monthSummary.topCode
                ? `${monthSummary.topCode} (${monthSummary.topCount})`
                : "—"}
            </div>
          </div>

          <div className="control-card report-card report-card--ahlamkom">
            <div className="report-card__title">ملخص الشهر أحلامكم</div>
            <div className="report-card__value">{monthSummary.otherTotal}</div>
          </div>

          <div className="control-card report-card report-card--group">
            <div className="report-card__title">تصنيف الشورت كود</div>
            <div className="report-card__meta">
              عدد الشورت كود القديم: {blockedShortCodeList.length}
            </div>
            <div className="report-card__meta">
              عدد أحلامكم: {uniqueOtherCodes}
            </div>
            <div className="report-card__meta">
              الأكواد القديمة: {blockedShortCodeList.join("، ")}
            </div>
          </div>
        </div>

        <div className="control-card report-card report-card--table">
          <div className="report-card__header">
            <div className="report-card__title">تفاصيل الشورت كود</div>
            <div className="control-select report-filter">
              <label
                className="control-select__label"
                htmlFor="shortcode-group-filter"
              >
                فلترة الشورت كود
              </label>
              <select
                id="shortcode-group-filter"
                className="selectpicker report-filter__select"
                value={shortCodeGroupFilter}
                onChange={this.handleShortCodeGroupFilter}
              >
                <option value="all">الكل</option>
                <option value="ahlamkom">أحلامكم</option>
                <option value="old">قديم</option>
              </select>
            </div>
          </div>
          {filteredShortCodeRows.length ? (
            <div className="report-table">
              <table className="table app-table report-table__table">
                <thead>
                  <tr>
                    <th>الشورت كود</th>
                    <th>اليوم</th>
                    <th>الشهر</th>
                    <th>التصنيف</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredShortCodeRows.map((row) => (
                    <tr
                      key={row.ShortCode}
                      className={
                        row.Group === "قديم" ? "report-row report-row--old" : ""
                      }
                    >
                      <td>{row.ShortCode}</td>
                      <td>{row.DayCount}</td>
                      <td>{row.MonthCount}</td>
                      <td>
                        <span
                          className={`report-tag ${
                            row.Group === "قديم"
                              ? "report-tag--old"
                              : "report-tag--new"
                          }`}
                        >
                          {row.Group}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="report-table__footer">
                    <td>{`الإجمالي: ${filteredShortCodeRows.length}`}</td>
                    <td>{shortCodeTotals.day}</td>
                    <td>{shortCodeTotals.month}</td>
                    <td>{`قديم: ${shortCodeTotals.old} | أحلامكم: ${shortCodeTotals.new}`}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          ) : (
            <div className="report-empty">لا توجد بيانات حالياً.</div>
          )}
        </div>

        {(dataAdib.length || dataMona.length) && (
          <div className="report-grid report-grid--two">
            <div className="control-card report-card report-card--table">
              <div className="report-card__title">المفسرين - اليوم</div>
              <div className="report-subtitle">الشيخ أديب</div>
              <Table
                columns={this.columnsMufasserCountDMY}
                data={dataAdib}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                footer={this.renderTotalsFooter(
                  this.columnsMufasserCountDMY,
                  totalsMufasserDMY
                )}
              />
              <div className="report-subtitle">منى</div>
              <Table
                columns={this.columnsMufasserCountDMY}
                data={dataMona}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                footer={this.renderTotalsFooter(
                  this.columnsMufasserCountDMY,
                  totalsMufasserDMYMona
                )}
              />
            </div>
            <div className="control-card report-card report-card--table">
              <div className="report-card__title">المفسرين - الشهر</div>
              <div className="report-subtitle">الشيخ أديب</div>
              <Table
                columns={this.columnsMufasserCountMY}
                data={dataAdibM}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                footer={this.renderTotalsFooter(
                  this.columnsMufasserCountMY,
                  totalsMufasserMY
                )}
              />
              <div className="report-subtitle">منى</div>
              <Table
                columns={this.columnsMufasserCountMY}
                data={dataMonaM}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                footer={this.renderTotalsFooter(
                  this.columnsMufasserCountMY,
                  totalsMufasserMYMona
                )}
              />
            </div>
          </div>
        )}

        {username === "qutaiba@salmustasharak.com" && (
          <div className="report-grid report-grid--two">
            <div className="control-card report-card report-card--table">
              <div className="report-card__title">قِتيبة - الشهر</div>
              <Table
                columns={this.columnsMufasserCountMY}
                data={dataQutaibaM}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                footer={this.renderTotalsFooter(
                  this.columnsMufasserCountMY,
                  totalsQutaibaMY
                )}
              />
            </div>
            <div className="control-card report-card report-card--table">
              <div className="report-card__title">قِتيبة - اليوم</div>
              <Table
                columns={this.columnsMufasserCountDMY}
                data={dataQutaiba}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                footer={this.renderTotalsFooter(
                  this.columnsMufasserCountDMY,
                  totalsQutaibaDMY
                )}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/components/report.jsx